module.exports = __webpack_public_path__ + "assets/img/gla_code.8779591a.gif";